/** First letter of the first name + first letter of the second name (if any), uppercased. */
export const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  const initials = parts.length === 1 ? parts[0][0] : parts[0][0] + parts[1][0];
  return initials.toUpperCase();
};
